<template>
  <v-card class="dv">
    <v-form>
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1"
                          step="1">{{$t('label_Customer_data')}}</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="e1 > 2"
                          step="2">{{$t('label_Functional_authority')}}</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3"
                          :complete="e1 > 3">{{$t('label_Email_Whitelist')}}</v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step step="4">{{$t('label_language')}}</v-stepper-step>

        </v-stepper-header>

        <v-stepper-items>
          <!-- 客户资料 -->
          <v-stepper-content step="1">
            <v-card class='cardbox'>
              <adduser ref="zjadduser"></adduser>
              <mrc_ess_submitBtn @cancel='edmit'
                                 @success='getuserzl'
                                 :cancelText="$t('label_cancel')"
                                 :successText="$t('label_The_next_step')"></mrc_ess_submitBtn>
            </v-card>

          </v-stepper-content>
          <!-- 功能权限 -->
          <v-stepper-content step="2">
            <v-card>
              <quanxian ref="zjquanxian"
                        :list='alltreelist'></quanxian>
            </v-card>
            <mrc_ess_submitBtn @cancel='changee1(1)'
                               @success='getuserqx'
                               :cancelText="$t('label_The_previous_step')"
                               :successText="$t('label_The_next_step')"></mrc_ess_submitBtn>
          </v-stepper-content>
          <!-- 邮箱白名单 -->
          <v-stepper-content step="3">
            <v-card>
              <baimingdan ref='zjbaimingdan'></baimingdan>
            </v-card>
            <mrc_ess_submitBtn @cancel='changee1(2)'
                               @success='getuseryx'
                               :cancelText="$t('label_The_previous_step')"
                               :successText="$t('label_The_next_step')"></mrc_ess_submitBtn>
          </v-stepper-content>
          <!-- 语言 -->
          <v-stepper-content step="4">
            <v-card>
              <yuyan ref="zjyuyan"></yuyan>
            </v-card>
            <mrc_ess_submitBtn @cancel='changee1(3)'
                               @success='submit'
                               :loading='btnloading'
                               :cancelText="$t('label_The_previous_step')"
                               :successText="$t('label_submit')"></mrc_ess_submitBtn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-form>
  </v-card>
</template>

<style lang="scss" scoped>
.btn {
  color: rgb(255, 173, 77);
  margin: 27px 60px;
  border-radius: 20%;
}
.btn:hover {
  background-color: rgb(255, 173, 77);
  color: white;
}
.btnbgd {
  background-color: #ccc;
  // margin: 0 30px;
  height: 80px;
}
.cardbox {
  background-color: white;
}
</style>

<script>
import adduser from './clientdetail/modules/adduser'
import baimingdan from './clientdetail/baimingdan'
import quanxian from './clientdetail/quanxianpeizhi'
import yuyan from './clientdetail/yuyan'
import { adduserclientdetail, getTreeList } from '@/service/api/clientmanage_api.js'
export default {
  components: {
    adduser,
    baimingdan, quanxian, yuyan
  },
  data () {
    return {
      btndisabled: false,
      btnloading: false,//按钮加载状态
      valid: false,
      e1: 1,
      alltreelist: [],
      // xzuserlist: {},//新增用户资料
      mrbase_sys_function_permission: {},//客户功能角色权限子表
      // mrbase_sys_client_contacts: {},//客户联系人信息表
      // mrbase_sys_client_language: {},	//客户语言子表
      // mrbase_sys_client_email_whitelist: {}	//客户邮箱白名单子表
    }
  },
  computed: {
    xzuserlist () {  //新增用户资料  
      if (!this.$refs.zjadduser.userdetail.client_address_province_id) {
        delete this.$refs.zjadduser.userdetail.client_address_province_id
      }
      if (!this.$refs.zjadduser.userdetail.client_address_city_id) {
        delete this.$refs.zjadduser.userdetail.client_address_city_id
      }
      return this.$refs.zjadduser.userdetail
    },
    // mrbase_sys_function_permission () {     //客户功能角色权限子表
    //   // console.log(this.$refs.zjquanxian.function_permission);
    //   return this.$refs.zjquanxian.getchangeref()
    // },
    mrbase_sys_client_contacts () {     //客户联系人信息表
      return this.$refs.zjadduser.desserts //数组
    },
    mrbase_sys_client_language () {     //客户语言子表
      return this.$refs.zjyuyan.mrbase_sys_client_language
    },
    mrbase_sys_client_email_whitelist () {
      const baimingdan = []     //客户邮箱白名单子表
      this.$refs.zjbaimingdan.states.forEach(item => {
        const obj = {
          "~table~": "mrbase_sys_client_email_whitelist",
          "whitelist_domain": item
        }
        baimingdan.push(obj)
      })  //数组
      return baimingdan
    },
    // dd () {
    //   return 13
    // }
  },
  async mounted () {
    // 获取默认tree树  无接口 alltreelist
    await this.gettreelist()
    // console.log(this.alltreelist);
  },
  methods: {
    async gettreelist () { //获取默认tree树  
      const listtree = await getTreeList()
      this.alltreelist = listtree.data
    },
    // 获取新增的用户资料，存取在vuex里面
    getuserzl (val) {
      if (this.$refs.zjadduser.formverify()) {
        this.e1 = 2
      }
      else {
        this.$myConfirm({ content: this.$t('message_The_information_was_not_entered_completely') }).then(() => { }).catch(() => { })
      }
    },
    emailbtnchange (v) {
      this.btndisabled = v
    },
    // 获取权限数据
    getuserqx (val) {
      //   return this.$refs.zjquanxian.getchangeref()
      // if (!this.mrbase_sys_function_permission.length > 0) return this.$myConfirm({
      //   content: this.$t('message_Permissions_cannot_be_empty')
      // })
      const obj = this.$refs.zjquanxian.success()
      if (obj.NoButton) {
        this.$Message({
          text: this.$t('message_Permissions_cannot_be_empty'),
          color: 'rgba(0,0,0,0.78)'
        })
      }
      else {
        this.mrbase_sys_function_permission = this.$clone(obj.button_uuid_arr).map(item => {
          return {
            function_uuid: item.uuid1,
            button_uuid: item.uuid,
          }
        })
        this.changee1(3)
      }
    },
    // 获取邮箱白名单
    getuseryx () {
      if (this.$refs.zjbaimingdan.isemail != '') {
        this.$myConfirm({
          content: this.$t('verify_The_mailbox_format_is_wrong')
        })
      }
      else {
        this.e1 = 4
      }
    },
    changee1 (v) {
      this.e1 = v
    },
    // 取消
    edmit () {
      this.$myConfirm({
        content: this.$t('message_Confirm_the_cancellation_of_the_edit')
      }).then(res => {
        this.$router.push({
          name: 'clientmanage'
        })
      }).catch(err => { })
    },
    // 总提交 添加新的用户  
    async submit () {
      // 获取子组件语言数据
      // console.log(this.mrbase_sys_client_language);
      // console.log(this.mrbase_sys_client_email_whitelist);
      // console.log(this.mrbase_sys_client_contacts);
      if (!this.mrbase_sys_client_language) return this.$myConfirm({
        content: this.$t('message_default_language_must_be_selected')
      })
      let login_url = window.location.origin + '/#' + '/login'
      let file1 = this.$refs.zjadduser.light_mode_icon_file
      let file2 = this.$refs.zjadduser.dark_mode_icon_file
      this.xzuserlist.mrbase_sys_function_permission = this.mrbase_sys_function_permission
      this.xzuserlist.mrbase_sys_client_contacts = this.mrbase_sys_client_contacts
      this.xzuserlist.mrbase_sys_client_email_whitelist = this.mrbase_sys_client_email_whitelist
      this.xzuserlist.mrbase_sys_client_language = this.mrbase_sys_client_language
      // console.log('xzuser', this.xzuserlist);
      this.btnloading = true
      await adduserclientdetail({ ...this.xzuserlist, login_url })
        .then(async res => {
          if (res.code == 200) {
            //上传文件 
            let p1 = this.$uploadFiles(file1, {
              module_uuid:'client',
              function_uuid: this.$store.state.menuFunctionUuid,
              attachment_data_table: 'mrbase_sys_clients',
              attachment_data_field: 'light_mode_icon',
              org_level_uuid: this.$store.state.currentCompany,
              uuid: res.data.uuid,
            })
            let p2 = this.$uploadFiles(file2, {
              module_uuid:'client',
              function_uuid: this.$store.state.menuFunctionUuid,
              attachment_data_table: 'mrbase_sys_clients',
              attachment_data_field: 'dark_mode_icon',
              org_level_uuid: this.$store.state.currentCompany,
              uuid: res.data.uuid,
            })
            await Promise.all([p1, p2])
            this.$Message({ text: this.$t('message_The_submission_was_successful') })
            this.$router.push({
              name: 'clientmanage'
            })
          }
        })
      this.btnloading = false
    }
  }
  ,
  watch: {
  }
}
</script>

<style scoped>
.v-stepper {
  box-shadow: none;
}
.v-stepper__header {
  background-color: #eeeef0;
  box-shadow: none;
}
.v-stepper__content {
  padding: 0px 0px;
}
</style>
